import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Typography } from '@mui/material';

import { PropertyTypeID } from '@klokhuis/core/ApiClient/Klokhuis';
import { useIntl } from '@klokhuis/core/Intl';
import { PageLayout } from '@klokhuis/core/PageLayout';
import { ROUTES } from '@klokhuis/core/Routing';
import { NavLink } from '@klokhuis/core/Routing/NavLink';
import { PropertyTypeIdPluralTranslationsTrimmed } from '@klokhuis/modules/Properties/translations';
import { CommonStyles } from '@klokhuis/styles/CommonStyles';

import styles from './PropertyLinksGrid.module.css';
import { useMediaIsDesktop } from '@klokhuis/utilities/Media/useMediaIsDesktop';

const propertyTypeAndCity = (propertyType: string, cityName: string) => {
  return `${propertyType.toLowerCase()}-${cityName.toLowerCase()}`;
};

const PropertyLinksGrid = () => {
  const { T } = useIntl();
  const isDesktop = useMediaIsDesktop();

  return (
    <PageLayout.SectionContainer className={styles.root}>
      <Typography
        variant={isDesktop ? 'h4' : 'h5'}
        className={CommonStyles.margin_bottom_3}
      >
        {T('LBL_HOME_LINK_NEST_TITLE')}
      </Typography>
      <div className={styles.content}>
        <div>
          <Typography variant="h6" className={styles.title}>
            {T('home_page.link_nest.properties_column.title')}
          </Typography>
          <div className={styles.links}>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T('listings_page.url.listing_type.generic'),
                  'chennai-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'home_page.link_nest.properties_column.link_text',
                  'Chennai',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T('listings_page.url.listing_type.generic'),
                  'coimbatore-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'home_page.link_nest.properties_column.link_text',
                  'Coimbatore',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T('listings_page.url.listing_type.generic'),
                  'madurai-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'home_page.link_nest.properties_column.link_text',
                  'Madurai',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T('listings_page.url.listing_type.generic'),
                  'tiruchirappalli-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'home_page.link_nest.properties_column.link_text',
                  'Tiruchirappalli',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T('listings_page.url.listing_type.generic'),
                  'tirunelveli-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'home_page.link_nest.properties_column.link_text',
                  'Tirunelveli',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T('listings_page.url.listing_type.generic'),
                  'tenkasi-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T('home_page.link_nest.properties_column.link_text', 'Tenkasi')}
              </Typography>
            </Button>
          </div>
        </div>
        <div>
          <Typography variant="h6" className={styles.title}>
            {T('LBL_GENERIC_HOUSE_OR_VILLA')}
          </Typography>
          <div className={styles.links}>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.HouseOrVilla
                    ],
                  ),
                  'chennai-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_HOUSE_OR_VILLA'),
                  'Chennai',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.HouseOrVilla
                    ],
                  ),
                  'coimbatore-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_HOUSE_OR_VILLA'),
                  'Coimbatore',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.HouseOrVilla
                    ],
                  ),
                  'tiruchirappalli-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_HOUSE_OR_VILLA'),
                  'Tiruchirappalli',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.HouseOrVilla
                    ],
                  ),
                  'madurai-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_HOUSE_OR_VILLA'),
                  'Madurai',
                )}
              </Typography>
            </Button>

                  <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.HouseOrVilla
                    ],
                  ),
                  'tirunelveli-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_HOUSE_OR_VILLA'),
                  'Tirunelveli',
                )}
              </Typography>
            </Button>

                  <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.HouseOrVilla
                    ],
                  ),
                  'tenkasi-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_HOUSE_OR_VILLA'),
                  'Tenkasi',
                )}
              </Typography>
            </Button>
          </div>
        </div>
        <div>
          <Typography variant="h6" className={styles.title}>
            {T('LBL_GENERIC_FARM_LAND_TRIMMED')}
          </Typography>
          <div className={styles.links}>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.FarmLand
                    ],
                  ),
                  'chennai-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_FARM_LAND_TRIMMED'),
                  'Chennai',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.FarmLand
                    ],
                  ),
                  'madurai-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_FARM_LAND_TRIMMED'),
                  'Madurai',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.FarmLand
                    ],
                  ),
                  'coimbatore-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_FARM_LAND_TRIMMED'),
                  'Coimbatore',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.FarmLand
                    ],
                  ),
                  'tiruchirapalli-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_FARM_LAND_TRIMMED'),
                  'Tiruchirapalli',
                )}
              </Typography>
            </Button>
              <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.FarmLand
                    ],
                  ),
                  'tirunelvelli-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_FARM_LAND_TRIMMED'),
                  'Tirunelvelli',
                )}
              </Typography>
            </Button>
             <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.FarmLand
                    ],
                  ),
                  'tenkasi-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_FARM_LAND_TRIMMED'),
                  'Tenkasi',
                )}
              </Typography>
            </Button>
          </div>
        </div>
        <div>
          <Typography variant="h6" className={styles.title}>
            {T('LBL_GENERIC_COMMERCIAL_PROPERTY_TRIMMED')}
          </Typography>
          <div className={styles.links}>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.CommercialLand
                    ],
                  ),
                  'chennai-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_COMMERCIAL_PROPERTY_TRIMMED'),
                  'Chennai',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.CommercialLand
                    ],
                  ),
                  'madurai-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_COMMERCIAL_PROPERTY_TRIMMED'),
                  'Madurai',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.CommercialLand
                    ],
                  ),
                  'coimbatore-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_COMMERCIAL_PROPERTY_TRIMMED'),
                  'Coimbatore',
                )}
              </Typography>
            </Button>
            <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.CommercialLand
                    ],
                  ),
                  'tiruchirappalli-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_COMMERCIAL_PROPERTY_TRIMMED'),
                  'Tiruchirappalli',
                )}
              </Typography>
            </Button>
             <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.CommercialLand
                    ],
                  ),
                  'tirunelvelli-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_COMMERCIAL_PROPERTY_TRIMMED'),
                  'Tirunelvelli',
                )}
              </Typography>
            </Button>
              <Button
              component={NavLink.Anchor}
              href={ROUTES.ListingSearchCity.url({
                typeAndCity: propertyTypeAndCity(
                  T(
                    PropertyTypeIdPluralTranslationsTrimmed[
                      PropertyTypeID.CommercialLand
                    ],
                  ),
                  'tenkasi-tamil-nadu',
                ),
              })}
              endIcon={<OpenInNewIcon color="primary" />}
              variant="link"
            >
              <Typography variant="subtitle1" className={styles.btn}>
                {T(
                  'LBL_LISTING_TYPE_FOR_SALE',
                  T('LBL_GENERIC_COMMERCIAL_PROPERTY_TRIMMED'),
                  'Tenkasi',
                )}
              </Typography>
            </Button>
          </div>
        </div>
      </div>
    </PageLayout.SectionContainer>
  );
};

export default PropertyLinksGrid;
